<template>
  <div class="xcxgl-con">
    <el-row>
      <el-col :span="12">
        <el-row class="tcf-row" style="padding-right: 10px">
          <el-col class="card">
            <div class="card-body">
              <div class="card-title">
                代码草稿箱
                <el-button type="text" class="right" @click="getDraft" icon="el-icon-refresh-right">刷新</el-button>
              </div>
              <div  class="card-content">
                <el-table
                  :data="draftData"
                  v-loading="draftloading"
                  height="350"
                  style="width: 100%;border: 1px solid #ebeef5">
                  <el-table-column
                    prop="draft_id"
                    label="草稿ID"
                    align="center"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="user_version"
                    label="版本号"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="user_desc"
                    label="版本描述">
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="160">
                    <template slot-scope="scope">
                      <el-button @click="addToTemp(scope.row)" size="mini" icon="el-icon-plus">添加到模板库</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row class="tcf-row" style="padding-left: 10px">
          <el-col class="card">
            <div class="card-body">
              <div class="card-title">
                小程序模板库(版本号带v的表示有直播)
                <el-button type="text" class="right" @click="getTemp" icon="el-icon-refresh-right">刷新</el-button>
              </div>
              <div class="card-content">
                <el-table
                  :data="tempData"
                  v-loading="temploading"
                  height="350"
                  style="width: 100%;border: 1px solid #ebeef5">
                  <el-table-column
                    prop="template_id"
                    label="模板ID"
                    align="center"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="user_version"
                    label="版本号"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="user_desc"
                    label="版本描述">
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="160">
                    <template slot-scope="scope">
                      <el-button @click="delTemp(scope.row)" size="mini" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-row class="tcf-row" style="padding-top: 0">
          <el-col class="card">
            <div class="card-body">
              <div class="card-title">
                经销商列表
              </div>
              <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                <el-form-item label="搜索关键字">
                  <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="getDealer"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" @click="getDealer">搜索</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-upload" @click="uploadCode">批量上传代码</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-s-promotion" @click="releaseCode">批量发布</el-button>
                </el-form-item>
              </el-form>
              <div class="card-content">
                <el-table
                  :data="dealerData"
                  v-loading="dealerloading"
                  height="450"
                  style="width: 100%;border: 1px solid #ebeef5"
                  @selection-change="handleSelectionChange">
                  <el-table-column
                    type="selection"
                    align="center"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="delname"
                    label="经销商"
                    align="center"
                    fixed="left"
                    width="160"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="appid"
                    label="Appid"
                    align="center"
                    width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="refreshToken"
                    min-width="200"
                    label="刷新令牌"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="templateid"
                    label="模板ID"
                    align="center"
                    fixed="right"
                    width="80"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="version"
                    label="版本号"
                    fixed="right"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="100"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4">已发布</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="info">未提交</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">审核中</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" type="success">待发布</el-tag>
                      <el-popover
                        v-if="scope.row.mark===3"
                        placement="top"
                        width="300"
                        trigger="hover">
                        <div style="font-weight: bold;margin-bottom: 10px">拒绝原因</div>
                        <div>{{scope.row.rson}}</div>
                        <el-tag :disable-transitions="true" size="mini" type="danger" slot="reference"><i class="el-icon-question"></i> 审核拒绝</el-tag>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="340">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="uploadCodeOne(scope.row)" icon="el-icon-upload">上传代码</el-button>
                      <el-button size="mini" :disabled="scope.row.mark!==2" @click="releaseOne(scope.row)" icon="el-icon-s-promotion">发布</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getWxTemplatedraftlist,
  addWxToTemplate,
  getWxTemplatelist,
  deleteWxTemplate,
  getWxBindedDealerList,
  commitWxCode,
  releaseWxCode
} from '@/api/pub'
export default {
  name: 'xcxgl',
  data() {
    return {
      draftloading: true,
      draftData: [],
      temploading: true,
      tempData: [],
      dealerloading: true,
      dealerData: [],
      multipleSelection: [],
      searchForm: {
        search: ''
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getDraft()
    this.getTemp()
    this.getDealer()
  },
  methods: {
    uploadCodeOne(row) {
      if (row.mark === 0) {
        if (this.tempData.length > 0) {
          this.$confirm('您确定要上传小程序代码吗?', '提示', {
            confirmButtonText: '是的',
            cancelButtonText: '再想想',
            type: 'warning'
          }).then(() => {
            commitWxCode({ delids: row.delid }).then(response => {
              this.$message({
                type: 'success',
                message: response.msg
              })
              this.getDealer()
            })
          }).catch(() => {})
        } else {
          this.$message.error('没有模板可上传')
        }
      }
    },
    releaseOne(row) {
      if (row.mark === 2) {
        this.$confirm('您确定要发布小程序吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          releaseWxCode({ delids: row.delid }).then(response => {
            this.$message({
              type: 'success',
              message: response.msg
            })
            this.getDealer()
          })
        }).catch(() => {})
      }
    },
    releaseCode() {
      if (this.multipleSelection.length > 0) {
        let delids = []
        for (const d of this.multipleSelection) {
          delids.push(d.delid)
        }
        this.$confirm('您确定要批量发布小程序吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          releaseWxCode({ delids: delids.join(',') }).then(response => {
            this.$message({
              type: 'success',
              message: response.msg
            })
            this.getDealer()
          })
        }).catch(() => {})
      } else {
        this.$message.error('至少选择一个经销商发布')
      }
    },
    uploadCode() {
      if (this.tempData.length > 0) {
        if (this.multipleSelection.length > 0) {
          let delids = []
          for (const d of this.multipleSelection) {
            delids.push(d.delid)
          }
          this.$confirm('您确定要批量上传小程序代码吗?', '提示', {
            confirmButtonText: '是的',
            cancelButtonText: '再想想',
            type: 'warning'
          }).then(() => {
            commitWxCode({ delids: delids.join(',') }).then(response => {
              this.$message({
                type: 'success',
                message: response.msg
              })
              this.getDealer()
            })
          }).catch(() => {})
        } else {
          this.$message.error('至少选择一个经销商上传代码')
        }
      } else {
        this.$message.error('没有模板可上传')
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getDealer() {
      this.dealerloading = true
      getWxBindedDealerList({
        search: this.searchForm.search
      }).then(response => {
        this.dealerData = response.data
        this.dealerloading = false
      })
    },
    getDraft() {
      this.draftloading = true
      getWxTemplatedraftlist().then(response => {
        this.draftData = response.data
        this.draftloading = false
      })
    },
    addToTemp(row) {
      this.$confirm('您确定要将此草稿添加到模板库吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        addWxToTemplate({ draft_id: row.draft_id }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getTemp()
        })
      }).catch(() => {})
    },
    getTemp() {
      this.temploading = true
      getWxTemplatelist().then(response => {
        this.tempData = response.data
        this.temploading = false
      })
    },
    delTemp(row) {
      this.$confirm('您确定要将此模板删除吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteWxTemplate({ template_id: row.template_id }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getTemp()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.xcxgl-con{
}
</style>
